import React from 'react'

import { ButtonPrimaryWrapper } from './styles'
import { IProps } from './types'

function ButtonPrimary({ children, className, ...rest }: IProps) {
	return (
		<ButtonPrimaryWrapper className={className}>
			<button {...rest}>{children}</button>
		</ButtonPrimaryWrapper>
	)
}

export default ButtonPrimary
